module.exports.breakpoints = [
  [0, "xsmall"],
  [471, "small"],
  [640, "medium"],
  [1024, "large"],
  [1440, "xlarge"],
  [1920, "xxlarge"]
];

module.exports.properties = {
  m: "margin",
  p: "padding"
};

module.exports.sides = {
  a: ["top", "right", "bottom", "left"],
  h: ["left", "right"],
  v: ["top", "bottom"],
  t: ["top"],
  r: ["right"],
  b: ["bottom"],
  l: ["left"]
};

module.exports.spaces = [0, 8, 16, 32, 64, 128, 256];



// WEBPACK FOOTER //
// ./src/theme/layout/layoutConfig.js